import React from "react";
import {Card, Col, NavLink, Row, Table} from '@themesberg/react-bootstrap';
import BasePage from "./../base/BasePage";
import label from "enqc-utilities/src/label/Label"
import PaginationTable from "../../components/PaginationTable";
import {getUser} from "../../utils/StorageUtil";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import queryString from 'query-string';
import {handleTimeAgo} from "enqc-utilities/src/utils/Utilities";
import SearchInput from "../../components/input/SearchInput";
import TableSortOption from "../../components/input/TableSortOption";
import SortOption from "enqc-utilities/src/model/SortOption";
import SmartDeviceDetailPage from "../subscribe/SmartDeviceDetailPage";

class SmartDeviceActivityPage extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            inputSearch: queryString.parse(this.props.query).search ? queryString.parse(this.props.query).search : "",
            user : getUser(),
            smartDeviceActivities:[],
            page: queryString.parse(props.query).page ? queryString.parse(props.query).page : 1,
            goodsInfos:[],
            goodsInfo:{},
            totalPage: 0,
            totalElement: 0,
            pageElement: 0,
            sortOption:SortOption.init(label.Latest,"ca.created",false)

        }
    }

    componentDidMount() {
        super.componentDidMount();
        if(this.props?.navBar?.current){
            this.props.navBar.current.updateNavBarItems([SmartDeviceActivityPage.PAGE_CONF])
        }

        this.closePreLoader()
        this.fetchSmartDeviceActivities()

    }

    componentWillReceiveProps(props, nextContext) {
        if (props != this.props) {
            let page = queryString.parse(props.query).page ? queryString.parse(props.query).page : 1
            let key = queryString.parse(props.query).tab ? queryString.parse(props.query).tab : label.All
            let inputSearch = queryString.parse(props.query).search ? queryString.parse(props.query).search : ""
            this.setState({
                page: page,
                key: key,
                inputSearch: inputSearch
            }, () => {
                this.fetchSmartDeviceActivities()
            })
        }
    }

    fetchSmartDeviceActivities = () => {
        let {smartDeviceActivities, sortOption, search} = this.state
        this.get(Endpoint.API.SMART_DEVICE_ACTIVITIES, {
            params :{
                ascending: sortOption.ascending,
                search: search,
                sortir: sortOption.sortir,
                page: this.state.page - 1,
            }
        }, null, response=>{
            if(response.code===200){
                let smartDeviceActivities = response.data
                let totalPage = response.totalPage
                let totalElement = response.totalElement
                let pageElement = response.pageElement
                this.setState({smartDeviceActivities:smartDeviceActivities,totalPage, totalElement, pageElement})
            }else{
                this.props.history.goBack();
            }
        }, false, true)
    }

    render() {
        let {smartDeviceActivities, page, pageElement, totalPage, totalElement, sortOption} = this.state
        return (
            <>
                {super.render()}
                <div className="table-settings mb-4">
                    <Row className="align-items-center">
                        <Col xs={8} md={6} lg={3} xl={7}>
                        </Col>
                        <Col xs={4} md={4} xl={1} className="ps-md-0 text-right">
                            <TableSortOption
                                sortOptions={
                                    [
                                        SortOption.init(label.Latest,"ca.created",false),
                                        SortOption.init(label.Oldest,"ca.created",true),
                                        SortOption.init(label.Name,"u.firstname",true),
                                        SortOption.init(label.Platform,"ca.platform",true),
                                    ]
                                }
                                sortOption={sortOption}
                                placeholder={label.SortBy}
                                onSelect={(sortOption) => {
                                    this.setState({sortOption},() => {
                                        this.fetchSmartDeviceActivities()
                                    })
                                }}
                                onReset={() => {
                                    this.setState({sortOption:{}},() => {
                                        this.fetchSmartDeviceActivities()
                                    })
                                }}/>
                        </Col>
                        <Col xs={8} md={6} lg={3} xl={4}>
                            <SearchInput onEnter={(search) => {
                                this.setState({search}, () => {
                                    this.fetchSmartDeviceActivities()
                                })
                            }} onEmpty={() => {
                                this.setState({search:""},() => {
                                    this.fetchSmartDeviceActivities()
                                })
                            }}/>
                        </Col>
                    </Row>
                </div>
                <Card border="light" className="table-wrapper table-responsive shadow-sm">
                    <Card.Body className="p-0">
                        <Table responsive className="table-flush table-striped table-sm text-wrap">
                            <thead className="thead-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">{label.DeviceId}</th>
                                <th scope="col">{label.Platform}</th>
                                <th scope="col">{label.User}</th>
                                <th scope="col">{label.Title}</th>
                                <th scope="col">{label.Description}</th>
                                <th scope="col">{label.TimeActivity}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {smartDeviceActivities.map((smartDeviceActivity, index) => {
                                return (
                                    <tr>
                                        <td>{((page - 1) * pageElement) + (index+1)}</td>
                                        <td>
                                            {
                                                smartDeviceActivity.platform==='TOOLBOX'?
                                                    (
                                                        <NavLink
                                                            style={{textDecoration:'underline'}}
                                                            className="p-0"
                                                            href={SmartDeviceDetailPage.ENDPOINT+"/"+smartDeviceActivity.deviceId+SmartDeviceDetailPage.ACTIVITY}>
                                                            {smartDeviceActivity.deviceId}
                                                        </NavLink>
                                                    ):(
                                                        <span>{smartDeviceActivity.deviceId}</span>
                                                    )
                                            }
                                        </td>
                                        <td>{smartDeviceActivity.platform?smartDeviceActivity.platform:"-"}</td>
                                        <td>{smartDeviceActivity.user.fullname}</td>
                                        <td>{smartDeviceActivity.title}</td>
                                        <td className="text-wrap">{smartDeviceActivity.description}</td>
                                        <td>{handleTimeAgo(smartDeviceActivity.created)}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                    </Card.Body>
                    <PaginationTable
                        onSelect={(page) => {
                            this.setState({page}, () => {
                                this.fetchSmartDeviceActivities()
                            })
                        }}
                        showingRow={smartDeviceActivities.length}
                        currentPage={page}
                        pageCount={totalPage}
                        totalElement={totalElement}/>
                </Card>
            </>
        );
    }

}
// export default Object.assign(SmartDeviceActivityPage, {ENDPOINT : "/deviceActivities"})
const ENDPOINT = "/deviceActivities"
const TITLE = label.DeviceActivity
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(SmartDeviceActivityPage, PAGE)


